import { AppState as State } from '@ducks/index';

export const getRefreshId = (state: State) => state.checking.refresh;

export const checkIsLoading = (state: State) => state.checking.isLoading;

export const checkIsSubmitting = (state: State) => state.checking.isSubmitting;

export const getCheckingList = (state: State) => state.checking.checkingList;
